import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AddReportItemsComponent } from './add-report-items/add-report-items.component';
import { AddPhotoModalComponent } from './add-photo-modal/add-photo-modal.component';
import { SendReportModalComponent } from './send-report-modal/send-report-modal.component';
import { ReportBuilderService } from './report-builder.service';
import {
    MiningShovel_LU_COMPART_TYPE,
    CompartMeasurementPoint,
    MeasurementPointReadings,
    MeasurementPointObservation,
    SaveReportParams,
    RecommendationParams,
    IntroductionParams,
    InspectionPhoto,
    MeasurementPointDetails,
    CompartInspection,
    AdditionalRecordDetails,
    SummaryParams,
    InspectionPhotoType,
    OverallComments,
    ChangePhotoCommentAPINames,
    MiningShovelInspectionOverview,
    ToggleHideAndShowResult
} from './report-builder-models';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { Side, SystemType } from '../../../../entities';
import { DatePipe } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ManageEquipmentService } from '../../../manage-equipment/manage-equipment.service';
import { TranslateService } from '../../../../../app/translate';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-report-builder',
    templateUrl: './report-builder.component.html',
    styleUrls: ['./report-builder.component.scss'],
    providers: [DatePipe]
})
export class ReportBuilderComponent implements OnInit {

    reportId: number = 0;
    MSInspectionID: number = 0;

    dateOfInspection: string = "";
    customerName: string = "";
    equipmentId: number = 0;
    equipmentMake: string = "";
    equipmentModel: string = "";
    unitNumber: string = "";
    undercarriageSMU: string = "";
    UCInspector: string = "";
    equipmentJobsite: string = "";
    equipmentCurrentSMU: string = "";
    RSReportClient: string = "";
    IsReleased:boolean=false;

    UCComponents: any = [];

    readingUoM: string = "";
    pdfUoM: string = "mm";

    Inspect_TrackShoes: CompartInspection = new CompartInspection();
    Inspect_TrackRollers: CompartInspection = new CompartInspection();
    Inspect_Tumblers: CompartInspection = new CompartInspection();
    Inspect_FrontIdlers: CompartInspection = new CompartInspection();
    Inspect_RareIdlers: CompartInspection = new CompartInspection();
    Inspect_CrawlerFrameGuide: CompartInspection = new CompartInspection();

    reportIntroduction: IntroductionParams = new IntroductionParams();
    reportSummary: SummaryParams = new SummaryParams();
    recommendedActions: RecommendationParams[] = [];

    imgPathLnH: string = "assets/LnH.png";
    equipmentPhoto: SafeResourceUrl = '';
    inspectionMandatoryPhotos: InspectionPhoto[] = [];
    introText: string = "";
    introText2: string = "";

    RS_EQUIPMENT_PHOTOS_ONLY: number = 1;
    RS_ALL_INSPECTION_PHOTOS: number = 2;

    ropeStyleId:number;
    // TT-1083
    showAxialGapCalculations: boolean = false;
    translateSubscription: Subscription;
    userLanguage: string = "english";
    constructor(private route: ActivatedRoute,
        public addReportItemsComponent: MatDialog,
        private _rbService: ReportBuilderService,
        public addPhotoModalComponent: MatDialog,
        private _sanitizer: DomSanitizer,
        private _router: Router,
        public sendReportModalComponent: MatDialog,
        private datePipe: DatePipe,
        private _notify: NotificationsService,
        private _loading: LoadingService,
        private _equipmentService:ManageEquipmentService,
        private _translate: TranslateService,
        private ref: ChangeDetectorRef,
    ) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.MSInspectionID = +params['id'];
            this._rbService.GetRSReportClient().subscribe(r => {
                if (r != null) {
                    this.RSReportClient = r;

                    // TT-1083
                    if (this.RSReportClient == 'L&H Industrial') {
                        this.showAxialGapCalculations = true;
                    } else {
                        this.showAxialGapCalculations = false;
                    }
                }
                this.loadData();
            });
            this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
            this.getReadingsUoM();
            this.getRopeShovelReportSyle();
        });
    }

    showMeasurementPointNoteSec(check, measurePoint){
        console.log("measurePoint", measurePoint)
        this._rbService.ToggleMeasurementPointNotes(measurePoint.measurePointId, this.reportId, check, measurePoint.side,  measurePoint.desc).subscribe(res => {
            if(res == null || res == undefined) return;
           var displayInfo = res.IsHiding ? "Hided Measurement Point Note" : "Showed Measurement Point Note"
            if(res.SavedResult){
                //measurePoint.isShow = !measurePoint.isShow;
                this._notify.success(`${displayInfo} on the report`)
            }
        });

    }

    getReadingsUoM() {
        this._rbService.GetUoM().subscribe(res => {
            if (res != null) {
                this.readingUoM = (res == "inch") ? '"' : 'mm';
                this.pdfUoM = (res == "inch") ? 'inch' : 'mm';
            }
        })
    }

    getRopeShovelReportSyle(){
        this._equipmentService.GetRopeShovelReportStyle(this.equipmentId).subscribe(res=>{
            if(res!= null){
                this.ropeStyleId = res;
            }
        })
    }

    viewInspection() {
        this._router.navigate(['rs-inspection', this.MSInspectionID]);
    }

    sendReport() {
        let sendReportModalRef = this.sendReportModalComponent.open(SendReportModalComponent, {
            width: '640px',
            height: '500px',
            data: { MSInspectionID: this.MSInspectionID, ReportUoM: this.pdfUoM , styleId:this.ropeStyleId}
        });
        sendReportModalRef.afterClosed().subscribe(res => {
            if (res != null) {
                // var sendToAddress: string = res.data;
                // this._rbService.SendReport(this.MSInspectionID, sendToAddress).subscribe(r2 => {
                //     if (r2 != null && r2 == true) {
                //         alert("Successfully sent report.");
                //     } else {
                //         alert("Failed to send report!");
                //     }
                // });
            }
        });
    }

    GetFrontImage(){
        
    }

    saveIntroText1(newValue: string) {
        this.reportIntroduction.IntroText1 = newValue;
        this.saveReportIntroduction();
    }

    saveIntroText2(newValue: string) {
        this.reportIntroduction.IntroText2 = newValue;
        this.saveReportIntroduction();
    }

    saveReportIntroduction() {
        this._rbService.SaveReportIntroduction(this.reportIntroduction).subscribe(res => {
            if ((res != null) && (res != -1)) {
                this.reportIntroduction.IntroId = res;
            }
        });
    }

    loadReportIntroduction() {
        this._rbService.GetReportIntroduction(this.reportId).subscribe(res => {
            if (res != null) {
                this.reportIntroduction = res;
                this.getCoverPhoto(res.CoverImage);
            }
            else {
                this.reportIntroduction.ReportId = this.reportId;
                this.reportIntroduction.IntroId = 0;
                this.reportIntroduction.CoverImage = 0;
                this.reportIntroduction.IntroText1 = this.introText;
                this.reportIntroduction.IntroText2 = this.introText2;

            }
            this.saveReportIntroduction();
        });
        this.loadEquipmentPhotos();
    }




    loadPrefilledContent() {
        this._rbService.GetPrefilledReportContent(this.equipmentId).subscribe(result => {
            if (result != null) {
                console.log(result);
                result.Systems.forEach(s => {
                    this.reportIntroduction.IntroText1 += `\b  ${Side[s.Side]}  ${SystemType[s.SystemTypeEnum]} CMU : ${s.CMU} `;
                })

            }
        });
    }

    loadReportSummary() {
        // Get the Report Summmary.
        this._rbService.GetReportSummary(this.reportId).subscribe(res => {
            if (res != null) {
                this.reportSummary = res;
            } else {
                // Summary doesn't exist, so pre-fill using the General Notes.
                this._rbService.GetGeneralNotes(this.MSInspectionID).subscribe(r2 => {
                    if (r2 != null) {
                        this.reportSummary.SummaryText = r2;
                    } else {
                        this.reportSummary.SummaryText = '';
                    }
                    this.reportSummary.ReportId = this.reportId;

                    // Now save this.
                    this.saveReportSummary(this.reportSummary.SummaryText);
                });
            }
        });
    }

    saveReportSummary(newValue: string) {
        this.reportSummary.SummaryText = newValue;
        this._rbService.SaveReportSummary(this.reportSummary).subscribe(res => {
            if ((res != null) && (res != -1)) {
                this.reportSummary.SummaryId = res;
            }
        });
    }

    saveReportRecommendationOverview(newValue: string) {
        this.reportSummary.RecommendationOverview = newValue;
        this._rbService.SaveReportSummary(this.reportSummary).subscribe(res => {
            if ((res != null) && (res != -1)) {
                this.reportSummary.SummaryId = res;
            }
        });
    }

    loadEquipmentPhotos() {
        this._rbService.GetEquipmentPhotos(this.MSInspectionID).subscribe(res => {
            if (res != null) {
                this.inspectionMandatoryPhotos = this.inspectionMandatoryPhotos.concat(res);
            }
        });
    }

    getCoverPhoto(photoId: number) {
        this._rbService.GetCoverPhoto(photoId).subscribe(res => {
            if (res != null) {
                this.equipmentPhoto = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + res.data);
            }
        });

        return "";
    }

    ReleaseReport(){
        console.log("REPORT", this.MSInspectionID)
        this._rbService.releaseRopeReport(this.MSInspectionID).subscribe(r=>{
            if (r.m_Item1) {
                this._notify.success('Released', r.m_Item2);
                this.IsReleased = true;
                this.loadData();
              } else {
                this._notify.error('Failed', 'Unable to release report. Contact TrackTreads support for help. ');
                console.log(r.m_Item2);
                this.IsReleased = false;
              }
            
            });
    }
    loadData() {
        this._loading.startLoading();
        this._rbService.GetMSInspectionDetails(this.MSInspectionID).subscribe(res => {
            //console.log(res);
            if (res != null) {
                this.dateOfInspection = this.datePipe.transform(res.dateOfInspection, 'dd-MMM-yyyy');               
                this.customerName = res.customerName;
                this.equipmentMake = res.equipmentMake;
                this.equipmentModel = res.equipmentModel;
                this.unitNumber = res.unitNumber;
                this.undercarriageSMU = res.undercarriageSMU;
                this.UCInspector = res.UCInspector;
                this.equipmentId = res.equipmentId;
                this.equipmentJobsite = res.equipmentJobsite;
                this.equipmentCurrentSMU = res.equipmentCurrentSMU;
                this.equipmentPhoto = "";
                this.IsReleased = res.IsReleased;


                var chainCMUText = "";
                res.systemPrefillContentViewModels.forEach(s => {
                    chainCMUText += ` ${Side[s.Side]} ${SystemType[s.SystemTypeEnum]} CMU : ${s.CMU} `;
                });

                this.introText = `On ${this.dateOfInspection},  ${this.RSReportClient} conducted an undercarriage inspection for ${this.customerName}'s  ${this.equipmentMake} ${this.equipmentModel} (Unit ${this.unitNumber}) located at ${this.equipmentJobsite}.  At the time of inspection the machine had  ${this.equipmentCurrentSMU} hours, ${chainCMUText}.  This undercarriage was supplied by ${this.RSReportClient}, and this inspection was provided for ${this.customerName} to determine the overall condition of the undercarriage.`;

                this.introText2 = "The following areas/components were covered in the inspection: \n • Left and right track belts (shoes, pins, hardware) \n  • Left and right tumblers (engagement, tooth profile, lubrication) \n • Left and right front idler assemblies (adjustment, thrust washer, lubrication) \n  • Left and right crawler frames (overall condition) \n The condition of each component will be discussed below, and the end of the report a summary with recommended action items has been provided.";

                var cID_trackShoes = MiningShovel_LU_COMPART_TYPE.Monoblock;
                var cID_trackRollers = MiningShovel_LU_COMPART_TYPE.TrackRoller;
                var cID_tumblers = MiningShovel_LU_COMPART_TYPE.Sprocket;
                var cID_frontIdlers = MiningShovel_LU_COMPART_TYPE.Idler;
                var cID_rareIdlers = MiningShovel_LU_COMPART_TYPE.RareIdler;
                var cID_crawlerFrameGuide = MiningShovel_LU_COMPART_TYPE.CrawlerFrameGuide;

                this.UCComponents = [
                    { componentName: "Track Shoes", componentId: cID_trackShoes, destination: this.Inspect_TrackShoes },
                    { componentName: "Track Rollers", componentId: cID_trackRollers, destination: this.Inspect_TrackRollers },
                    { componentName: "Tumblers", componentId: cID_tumblers, destination: this.Inspect_Tumblers },
                    { componentName: "Front Idlers", componentId: cID_frontIdlers, destination: this.Inspect_FrontIdlers },
                    { componentName: "Rear Idlers", componentId: cID_rareIdlers, destination: this.Inspect_RareIdlers },
                    { componentName: "Crawler Frame Guide", componentId: cID_crawlerFrameGuide, destination: this.Inspect_CrawlerFrameGuide }
                ];

                this.UCComponents.forEach(c => {
                    this.loadMeasurementPoints(c.componentId, c.destination);
                    this.loadMandatoryImages(c.componentId, c.destination);
                    this.loadAdditionalImages(c.componentId, c.destination);
                    this.loadAdditionalRecords(c.componentId, c.destination);
                    this.loadCalculatedRecords(c.componentId, c.destination);
                    this.loadOverallComments(c.componentId, c.destination);
                });

                this.saveReport();
                this.getRopeShovelReportSyle();
            }
            else{
                this._loading.finishedLoading();
            }

        });
    }
    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
      }
    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
      }
    
    loadOverallComments(id: number, dst: CompartInspection) {
        // Initialise
        dst.OverallComments = new OverallComments();
        dst.OverallComments.CompartTypeId = id;
        dst.OverallComments.Id = 0;
        dst.OverallComments.Comments = "";
        dst.OverallComments.ReportId = 0;

        // Get the data from the server.
        this._rbService.GetOverallComments(this.MSInspectionID, id).subscribe(res => {
            if (res != null) {
                dst.OverallComments = res;
            }
        });
    }

    saveOverallComments(newValue: string, dst: CompartInspection) {
        dst.OverallComments.Comments = newValue;
        dst.OverallComments.ReportId = this.reportId;
        this._rbService.SaveOverallComments(dst.OverallComments).subscribe(res => {
            if ((res != null) && (res > 0)) {
                dst.OverallComments.Id = res;
            }
        });
    }

    loadMeasurementPoints(id: number, dst: CompartInspection) {
        // Obtain the list of all compart measurement points.
        this._rbService.GetCompartMeasurementPoints(id, this.equipmentId,this.reportId).subscribe(res => {
            if (res != null) {
                dst.MeasurementPoints = [];
                // Loop over all measurement points.
                for (var i = 0; i < res.length; i++) {

                    var MP_NumberOfMeasurements: number = res[i].numberOfMeasurements;
                    var MP_Name: string = res[i].measurePointName;
                    var MP_ID: number = res[i].measurePointId;

                    // Define a new measurement point.
                    var MP = new MeasurementPointDetails();

                    // Store this record into the list of measurement points for this compart.
                    dst.MeasurementPoints.push(MP);

                    this.defineNewMeasurementPoint(MP_ID, MP_Name, MP_NumberOfMeasurements, dst, MP);
                }
            }
        });
    }

    defineNewMeasurementPoint(id: number, name: string, numberOfMeasurements: number, dst: CompartInspection, MP: MeasurementPointDetails) {
        // Define measurement point.

        //console.log(MP);
        var newMeasurementPoint = MP;
        newMeasurementPoint.MeasurePointId = id;
        newMeasurementPoint.MeasurePointName = name;
        newMeasurementPoint.NumberOfMeasurements = numberOfMeasurements;
        newMeasurementPoint.Readings = [];
        newMeasurementPoint.Images = [];
        newMeasurementPoint.Observations = [];
        
        var GetMPReadings = this._rbService.GetMeasurementPointReadings(this.MSInspectionID, id);
        var GetMPImages = this._rbService.GetMeasurementPointImages(this.MSInspectionID, id);
        var GetMPObservations = this._rbService.GetMeasurementPointObservations(this.MSInspectionID, id);


      
        Observable.forkJoin(GetMPReadings, GetMPImages, GetMPObservations).subscribe(
            data => {
                // Obtain the measurement point readings.
                if (data[0] != null) {
                    newMeasurementPoint.Readings = newMeasurementPoint.Readings.concat(data[0]);
                    if (newMeasurementPoint.Readings.length > 0 && newMeasurementPoint.Readings[0].isHiddenAll || newMeasurementPoint.Readings.length ==0) {                    
                        for(let i = 0; i<newMeasurementPoint.Readings.length; i++){
                           if(newMeasurementPoint.Readings[i].listOfReadings.length >0){
                               newMeasurementPoint.isHidden = false;
                               break;
                           }                              
                       }     
                    }
                }

                // Obtain the measurement point observations.
                if (data[2] != null) {
                    newMeasurementPoint.Observations = [];
                    newMeasurementPoint.Observations = newMeasurementPoint.Observations.concat(data[2]);
                    if(newMeasurementPoint.Observations.length > 0){
                        newMeasurementPoint.isHidden = false;                                            
                    } 
                    else{
                        newMeasurementPoint.isHidden = true;
                    }     
                }

                // Obtain the measurement point images.
                if (data[1] != null) {
                    newMeasurementPoint.Images = [];
                    newMeasurementPoint.Images = newMeasurementPoint.Images.concat(data[1]);
                    if(newMeasurementPoint.Images.length > 0)
                        newMeasurementPoint.isHidden = false;
                     else{
                        newMeasurementPoint.isHidden = true;
                     }   
                    // if(newMeasurementPoint.Images.length == 0){
                    //     newMeasurementPoint.isHidden = true;  
                    //     for(let i = 0; i<newMeasurementPoint.Images.length; i++){
                    //         if(newMeasurementPoint.Images[i].isHidden == false)
                    //             newMeasurementPoint.isHidden = false;
                    //     }                        
                    // }    
                }            
               
                MP = newMeasurementPoint;
                 //console.log(MP);
            },
            error => console.error(error)
        );
    }



    loadMandatoryImages(id: number, dst: CompartInspection) {
        dst.MandatoryImages = [];
        this._rbService.GetMandatoryPhotos(this.MSInspectionID, id).subscribe(res => {
            if (res != null) {
                dst.MandatoryImages = dst.MandatoryImages.concat(res);
            }
        });
    }

    loadAdditionalImages(id: number, dst: CompartInspection) {
        dst.AdditionalImages = [];
        this._rbService.GetAdditionalPhotos(this.MSInspectionID, id).subscribe(res => {
            if (res != null) {
                dst.AdditionalImages = dst.AdditionalImages.concat(res);
            }
        });
    }

    loadAdditionalRecords(id: number, dst: CompartInspection) {
        dst.AdditionalRecords = [];
        this._rbService.GetAdditionalRecords(this.MSInspectionID, id).subscribe(res => {
            if (res != null) {
                dst.AdditionalRecords = dst.AdditionalRecords.concat(res);
            }
        });
        this._rbService.GetStatusOfAdditionalRecord(id, this.MSInspectionID).subscribe(r2 => {
            if (r2 != null) {
                dst.isAdditionalRecordsHidden = r2;
            }
        });
    }

    loadCalculatedRecords(id: number, dst: CompartInspection) {
        dst.CalculatedRecords = [];
        if (id == MiningShovel_LU_COMPART_TYPE.Idler) {
            this._rbService.GetAxialGapCalculations(this.MSInspectionID).subscribe(r3 => {
                if (r3 != null) {
                    dst.CalculatedRecords = r3;
                }
            });
        }
    }

    addItemsToReport() {
        let addReportItemsRef = this.addReportItemsComponent.open(AddReportItemsComponent, {
            width: '640px',
            height: '540px',
            data: {}
        });
        addReportItemsRef.afterClosed().subscribe(() => {

        });
    }

    addPhotoToReport() {
        let addPhotoModalRef = this.addPhotoModalComponent.open(AddPhotoModalComponent, {
            width: '780px',
            height: '720px',
            data: {
                inspectionID: this.MSInspectionID,
                photoType: this.RS_EQUIPMENT_PHOTOS_ONLY
            }
        });
        addPhotoModalRef.afterClosed().subscribe(res => {
            if (res != null) {
                this.reportIntroduction.CoverImage = res.data.id;
                this.getCoverPhoto(res.data.id);
                this.saveReportIntroduction();
            }
        });
    }

    loadRecommendations() {
        this._rbService.GetRecommendations(this.reportId).subscribe(res => {

            if (res != null) {
                this.recommendedActions = [];
                this.recommendedActions = this.recommendedActions.concat(res);
            }
        });
    }

    addNewRecommendation() {
        var recommendationParams: RecommendationParams = {
            ReportId: this.reportId,
            RecommendationId: 0,
            RecommendationTitle: "",
            RecommendationText: ""
        };
        this.recommendedActions = this.recommendedActions.concat(recommendationParams);
    }

    saveReport() {
        var today = new Date();
        var params: SaveReportParams = {
            MSInspectionID: this.MSInspectionID,
            createdUser: 0,
            createdDate: today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear()
                + ' ' + (today.getHours) + ':' + (today.getMinutes) + ':' + (today.getSeconds)
        }
        this._rbService.SaveReport(params).subscribe(res => {
            if (res > 0) {
                console.log("Saved report " + res);
                this.reportId = res;
                this.loadReportIntroduction();
                this.loadReportSummary();
                this.loadRecommendations();
            }
            this._loading.finishedLoading();
        });
    }

    saveRecommendation(params: RecommendationParams) {
        params.ReportId = this.reportId;
        this._rbService.SaveRecommendation(params).subscribe(res => {
            if (res > 0) {
                params.RecommendationId = res;
                //console.log("Saved recommendation " + res);
            }
        });
    }

    deleteRecommendation(params: RecommendationParams) {
        this._rbService.DeleteRecommendation(params.RecommendationId).subscribe(res => {
            if (res > 0) {
                console.log("Removed recommendation.");
                this.loadRecommendations();
            }
        });
    }

    ////////////////////////////////////
    // Show or hide items from report //
    ////////////////////////////////////
    toggleInspectionMandatoryPhoto(img: number) {
        this._rbService.ToggleInspectionMandatoryPhoto(img, this.reportId).subscribe(res => {
           this.notifyUserAboutImages(res);
           console.log("Inspection Mandatory Photo");
        });
    }


    notifyUserAboutImages(result : ToggleHideAndShowResult){
        if(result == null || result == undefined) return;
        var displayInfo = result.IsHiding ? "Hided image" : "Showed image"
        if(result.SavedResult){
            this._notify.success(`${displayInfo} on the report`)
        }
    }

    toggleComparttypeMandatoryPhoto(img: number) {
        this._rbService.ToggleComparttypeMandatoryPhoto(img, this.reportId).subscribe(res => {
            this.notifyUserAboutImages(res);
            console.log("Toggle Comparttype Mandatory Photo");
        });
    }

    toggleComparttypeAdditionalPhoto(img: number) {
        this._rbService.ToggleComparttypeAdditionalPhoto(img, this.reportId).subscribe(res => {
            this.notifyUserAboutImages(res);
            console.log("Comparttype Additional Photo");
        });
    }

    toggleMeasurementPointPhoto(img) {
        this._rbService.ToggleMeasurementPointPhoto(img.imageId, this.reportId, img.isHidden).subscribe(res => {
            this.notifyUserAboutImages(res);
            console.log(" Measurement Point Photo" + res.Id);
        });
    }

    toggleMeasurementPointRecord(measurePoint: number) {
        this._rbService.ToggleMeasurementPointRecord(measurePoint, this.reportId).subscribe(res => {
            if(res == null || res == undefined) return;
            var displayInfo = res.IsHiding ? "Hided Measurement point reading record" : "Showed Measurement point reading record"
            if(res.SavedResult){              
                this._notify.success(`${displayInfo} on the report`)
            }
        });
    }

    toggleComparttypeAdditionalRecord(compartTypeID: number) {
        this._rbService.ToggleComparttypeAdditionalRecord(compartTypeID, this.reportId).subscribe(res => {
            if(res == null || res == undefined) return;
            var displayInfo = res.IsHiding ? "Hided Additional record" : "Showed Addtional record"
            if(res.SavedResult){              
                this._notify.success(`${displayInfo} on the report`)
            }
        });
    }

    toggleShowOrHideMP(checked,measurePoint: MeasurementPointDetails) {
        
        this._rbService.ToggleMeasurementPoint(measurePoint.MeasurePointId, this.reportId).subscribe(res => {
            if(res == null || res == undefined) return;
            var displayInfo = res.IsHiding ? "Hidden on the Report" : "Showing on the Report"
            if(res.SavedResult){
                measurePoint.isHidden = !measurePoint.isHidden;
                this._notify.success(`${displayInfo} on the report`)
            }
        });
    }

    //////////////////
    // Image resize //
    //////////////////
    resizeInspectionMandatoryImage(isLarge: boolean, photoId: number) {
        this.toggleReportImageResize(isLarge, photoId, InspectionPhotoType.Inspection_Mandatory_Photo);
    }

    resizeComparttypeMandatoryImage(isLarge: boolean, photoId: number) {
        this.toggleReportImageResize(isLarge, photoId, InspectionPhotoType.Comparttype_Mandatory_Photo);
    }

    resizeComparttypeAdditionalImage(isLarge: boolean, photoId: number) {
        this.toggleReportImageResize(isLarge, photoId, InspectionPhotoType.Comparttype_Additional_Photo);
    }

    resizeMeasurementPointImage(isLarge: boolean, photoId: number) {
        this.toggleReportImageResize(isLarge, photoId, InspectionPhotoType.Measurement_Point_Photo);
    }

    toggleReportImageResize(isLarge: boolean, photoId: number, photoType: number) {
        this._rbService.ToggleReportImageResize(isLarge, photoId, photoType, this.reportId).subscribe(res => {
            if (res != null) {
                //console.log(res);
            }
        });
    }






    changedInspectionMandatoryPhotoComment(event) {
        this._rbService.ChangeImageComment(event.id, event.newComment, ChangePhotoCommentAPINames.ChangeInspectionMandatoryPhotoComment).subscribe(r => {
            this.notifyPopup(r);
        });
    }

    changeMandatoryImageComments(event) {
        this._rbService.ChangeImageComment(event.id, event.newComment, ChangePhotoCommentAPINames.ChangeMandatoryImageComment).subscribe(r => {
            this.notifyPopup(r);
        });
    }


    changeAdditionalImageComment(event, AdditionalImages) {
        this._rbService.ChangeImageComment(event.id, event.newComment, ChangePhotoCommentAPINames.ChangeAdditionalImageComment).subscribe(r => {
            this.notifyPopup(r);
        });
    }

    changedMeasurementPointsPhotoComment(event) {
        this._rbService.ChangeImageComment(event.id, event.newComment, ChangePhotoCommentAPINames.ChangedMeasurementPointsPhotoComment).subscribe(r => {
            this.notifyPopup(r);
        });
    }

    notifyPopup(result) {
        if (result) {
            this._notify.success("Sucessfully changed image comment")
        }
        else {
            this._notify.error("Failed to update image comment");
        }
    }
}
